import React, {useRef} from "react";
import {Card} from "../global/Card";
import {Line} from "../global/Line";

export const Deploy = (props) => {

  const data = props.data;

  const cardsData = data.items

  const titleRef = useRef(null);
  const labelRef = useRef(null);

  const renderCards = () => {
    return cardsData.map((card, index) => (
      <div className="col-md-6" key={index}>
        <Card
          color={card.color}
          title={card.title}
          text={card.text}
          button={card.button}
          classes="mb-4 mb-md-0"
        />
      </div>
    ))
  }

  return (
    <section className='py-lg-16 py-11'>
      <div className="container">
        <div className="row mb-6">
          <div className="col-xl-8 col-lg-9 col-md-7">
            <h2 className="mb-6 mb-lg-0 d-inline-flex flex-wrap align-items-start">
              <span className="zg-text-bg bg-yellow mb-1 mb-md-2 me-2">{data.titlePart1}</span>
              <span className="zg-label bg-yellow me-2">{data.suptext1}</span>
              <span className="zg-text-bg bg-white me-2 mb-1 mb-md-2">{data.titlePart2}</span>
              <span className="zg-label bg-white me-2">{data.suptext2}</span>
              <span className="zg-text-bg bg-purple mb-1 mb-md-2" ref={titleRef}>{data.titlePart3}</span>
            </h2>
          </div>
        </div>
        <div className="row mb-11">
          <div className="col"></div>
          <div className="col-lg-6">
            <div className="row align-items-end">
              <div className="col-md-6 order-1">
                <p className="zg-text-lg mb-4 mb-md-0 order-md-0 d-none d-md-block" dangerouslySetInnerHTML={{__html: data.columnLeft}}>
                </p>
                <p className='mb-0 d-block d-md-none'>
                  {data.columnRight}
                </p>
              </div>
              <div className="col-md-6 order-0 order-md-1">
                <span className="zg-label bg-purple me-2" ref={labelRef}>{data.number}</span>
                <span className="zg-label bg-purple">{data.subtitle}</span>
                <p className="zg-text-lg mb-4 mt-5 mb-md-0 order-md-0 d-block d-md-none" dangerouslySetInnerHTML={{__html: data.columnLeft}}>
                </p>
                <p className='mt-5 mb-0 d-none d-md-block'>
                  {data.columnRight}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {renderCards()}
        </div>
        <Line start={titleRef} endAnchor="left" end={labelRef} color={"#9E76FF"}/>
      </div>
    </section>
  )
}
